import { EulaTaxonomy } from '../types';

const escapeHtml = (text: string) =>
  text.replace(
    /[&<>"']/g,
    (char) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char] ?? char
  );

export function buildEulaPrintHtml(eula: EulaTaxonomy, title: string, updatedLabel: string) {
  const paragraph = (text: string | undefined, className = '') =>
    text ? `<p class="${className}">${escapeHtml(text)}</p>` : '';

  const body = eula.domains
    .map((domain) => {
      const intro = domain.intro
        .map((p) => `${paragraph(p.title, 'strong')}${paragraph(p.text)}`)
        .join('');
      const sections = domain.sections
        .map((section) => {
          const heading = section.title
            ? `${section.number}. ${section.title}`
            : `${section.number}.`;
          const paragraphs = section.paragraphs
            .map((p) => paragraph(p.number ? `${p.number} ${p.text}` : p.text))
            .join('');
          return `<h3>${escapeHtml(heading)}</h3>${paragraphs}`;
        })
        .join('');
      return `${domain.title ? `<h2>${escapeHtml(domain.title)}</h2>` : ''}${intro}${sections}`;
    })
    .join('');

  const updated = eula.updatedOn ? paragraph(`${updatedLabel}: ${eula.updatedOn}`, 'muted') : '';

  return `<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(title)}</title><style>
body{font-family:Roboto,Arial,sans-serif;font-size:11pt;line-height:1.4;margin:2cm;color:#000}
h1{font-size:18pt}h2{font-size:14pt;margin-top:1.5em}h3{font-size:12pt}
.strong{font-weight:600}.muted{color:#555}
</style></head><body><h1>${escapeHtml(title)}</h1>${updated}${body}</body></html>`;
}

/** Opens the browser print dialog for the EULA only, so users can print or save it as PDF. */
export function printEula(eula: EulaTaxonomy, title: string, updatedLabel: string) {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const frameWindow = iframe.contentWindow;
  if (!frameWindow) {
    iframe.remove();
    return;
  }

  frameWindow.document.open();
  frameWindow.document.write(buildEulaPrintHtml(eula, title, updatedLabel));
  frameWindow.document.close();
  frameWindow.addEventListener('afterprint', () => iframe.remove());
  frameWindow.focus();
  frameWindow.print();
}
